import { z } from 'zod';
import { QuoteStatus } from '../enums.js';
const isoDate = z.string().datetime().or(z.string().regex(/^\d{4}-\d{2}-\d{2}$/));
export const quoteLineInput = z.object({
    description: z.string().min(1).max(500),
    quantity: z.coerce.number().min(0).default(1),
    unitPrice: z.coerce.number().min(0),
    vatRate: z.coerce.number().min(0).max(100).default(22),
    order: z.coerce.number().int().default(0),
});
export const createQuoteInput = z.object({
    clientId: z.string(),
    projectId: z.string().optional().nullable(),
    issueDate: isoDate.optional().nullable(),
    validUntil: isoDate.optional().nullable(),
    title: z.string().max(200).optional().nullable(),
    introMessage: z.string().max(4000).optional().nullable(),
    termsAndConditions: z.string().max(8000).optional().nullable(),
    notes: z.string().max(2000).optional().nullable(),
    lines: z.array(quoteLineInput).min(1),
    status: z.nativeEnum(QuoteStatus).default(QuoteStatus.BOZZA),
});
export const updateQuoteInput = createQuoteInput.partial();
export const sendQuoteEmailInput = z.object({
    to: z.string().email(),
    cc: z.string().email().optional(),
    subject: z.string().min(1).max(200),
    message: z.string().max(4000),
});
export const signQuoteInput = z.object({
    signerName: z.string().trim().min(2).max(200),
    signerEmail: z.string().email().optional(),
    // signature = data URL base64 PNG. Limite ~1MB di payload (~750KB PNG decoded)
    // per evitare DoS: un canvas 800x200 PNG occupa ~30-80KB in pratica.
    signatureDataUrl: z.string()
        .min(50)
        .max(1_500_000)
        .regex(/^data:image\/(png|jpeg);base64,/, 'Formato firma non valido'),
    acceptTerms: z.literal(true),
});
export const rejectQuoteInput = z.object({
    reason: z.string().max(2000).optional(),
});
//# sourceMappingURL=quote.js.map